import _ from 'lodash';

const defaults = {
  color: 'blue',
  size: 'medium',
};

const btn = (...options) => {
  const final = _.defaults(_.defaults({}, ...options), defaults);

  return `btn ${_.map(final, (value, key) => `btn--${key}_${value}`).join(
    ' ',
  )}`;
};

export default btn;
